<template>
    <div>
        <v-form ref="refMain">
            <v-container fluid>
                <v-row fluid>
                    <v-col cols="12" sm="5" md="4" lg="4" class="pa-0">
                        <v-menu
                            v-model="dFInicioMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dFInicio"
                                    label="Fecha Inicio"
                                    prepend-inner-icon="event_note"
                                    readonly
                                    filled
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="[v => !!v || 'El campo es requerido']"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dFInicio"
                                @input="dFInicioMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" class="pa-0">
                        <v-menu
                            v-model="dFFinMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dFFin"
                                    label="Fecha Fin"
                                    prepend-inner-icon="event_note"
                                    readonly
                                    filled
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="[v => !!v || 'El campo es requerido']"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dFFin"
                                @input="dFFinMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3" class="pa-0">
                        <v-select v-model="dEstado" label="Estado"
                            :items="['', 'EN PROCESO', 'FINALIZADO']"
                            filled prepend-inner-icon="invert_colors"></v-select>
                    </v-col>
                    <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                        <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon>search</v-icon> Buscar</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-data-table :headers="dTable.headers" :items="dMatConsejerias" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title><v-btn @click="$router.push(`/AlumnoItem/${item.IdAlumno}/Accion/2`);" color="info" block><v-icon>check</v-icon> Seleccionar</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:[`item.Estado`]="{ item }">
                <v-icon v-if="item.Estado=='FINALIZADO'" color="success" title="FINALIZADO">check_circle</v-icon>
                <v-icon v-else color="warning" title="EN PROCESO">watch_later</v-icon>
            </template>
        </v-data-table>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
name: 'MatConsejeriaSearch',
mounted(){
    this.fuSearch();
},
data: () => ({
    dEstado: 'EN PROCESO',
    dFInicio: moment().subtract(30,'d').format('YYYY-MM-DD'),
    dFInicioMenu: false,
    dFFin: moment().format('YYYY-MM-DD'),
    dFFinMenu: false,
    dMatConsejerias: [],
    dSnackbar: false,
    dTable: {
        headers: [
            {value: 'actions', text: '...', sortable: false},
            {value: 'IdConsejeria', text: 'IdConsejeria', align: ' d-none'},
            {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
            {value: 'prialumno.Alumno', text: 'Alumno'},
            {value: 'Categoria', text: 'Categoria'},
            {value: 'Detalle', text: 'Situacion del Alumno'},
            {value: 'Procedimiento', text: 'Accion del Tutor'},
            {value: 'Fecha', text: 'Fecha'},
            {value: 'FechaProgramado', text: 'FechaProgramado'},
            {value: 'Estado', text: 'Estado'}
        ],
        loading: false,
        search: null,
    }
}),
computed: {
    ...mapState(['ssUser']),
},
methods: {
    fuSearch(){
        if(!this.$refs.refMain.validate()){
            this.dSnackbar = true;
        } else {
            this.fuMatconsejeriaByIdPersonalByEstadoByFechas();
        }
    },
    async fuMatconsejeriaByIdPersonalByEstadoByFechas(){
        this.dTable.loading = true;
        let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
        let vFFin =this.dFFin.substring(0,10).split("-").join("");
        try {
            const response = await this.$apollo.query({
                query: gql`query matconsejeriaByIdPersonalByEstadoByFechas($IdPersonal: String, $Estado: String, $FInicio: String!, $FFin: String!, $Fecha: String){
                    matconsejeriaByIdPersonalByEstadoByFechas(IdPersonal:$IdPersonal, Estado:$Estado, FInicio:$FInicio, FFin:$FFin, Fecha: $Fecha){
                        IdConsejeria
                        Consejero
                        IdAlumno
                        Categoria
                        Detalle
                        Procedimiento
                        Fecha
                        FechaProgramado
                        Estado
                        prialumno{
                            Alumno
                        }
                    }
                }`,
                variables: {
                    IdPersonal: this.ssUser.IdPersonal,
                    Estado: this.dEstado,
                    FInicio: vFInicio,
                    FFin: vFFin,
                    Fecha: new Date().toISOString()
                }
            })
            console.log(response.data.matconsejeriaByIdPersonalByEstadoByFechas);
            this.dMatConsejerias = [];
            this.dMatConsejerias = response.data.matconsejeriaByIdPersonalByEstadoByFechas;
        } catch (error) {
            console.log(error);
            Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
        } finally {
            this.dTable.loading = false
        }
    }
}
}
</script>